import { ApiTokenType } from "./models";

export const isApiTokenType = (token: string): token is ApiTokenType => {
  return token === "impersonation" || token === "scim";
};
